var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-main-inner',{attrs:{"title":"培训统计"}},[_c('train-data'),_c('train-time-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }